import { render, staticRenderFns } from "./promote_milestone_modal.vue?vue&type=template&id=54db3d88&"
import script from "./promote_milestone_modal.vue?vue&type=script&lang=js&"
export * from "./promote_milestone_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports